module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid3_800x627.55c9c71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid3_800x627.jpg
// module id = HXAR
// module chunks = 0